import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DiscoveryTabs = ({
  tabs,
  activeTab,
  onTabChange,
  tabsScrollRef,
  canScrollLeft,
  canScrollRight,
  scrollTabs,
}) => {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="mb-6 sm:mb-8">
      <div className="relative">
        <button
          type="button"
          onClick={() => scrollTabs(-1)}
          aria-label="Scroll categories left"
          data-testid="tabs-scroll-left"
          className={`absolute left-0 top-1/2 -translate-y-1/2 z-10 h-8 w-8 grid place-items-center rounded-full bg-background/95 border border-border shadow-md text-foreground transition-opacity hover:bg-accent ${canScrollLeft ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={() => scrollTabs(1)}
          aria-label="Scroll categories right"
          data-testid="tabs-scroll-right"
          className={`absolute right-0 top-1/2 -translate-y-1/2 z-10 h-8 w-8 grid place-items-center rounded-full bg-background/95 border border-border shadow-md text-foreground transition-opacity hover:bg-accent ${canScrollRight ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <ChevronRight className="h-4 w-4" />
        </button>
        {/* Edge fade hints to suggest scrollable content */}
        {canScrollLeft && (
          <div className="absolute left-0 top-0 bottom-0 w-10 z-[5] pointer-events-none bg-gradient-to-r from-background to-transparent" />
        )}
        {canScrollRight && (
          <div className="absolute right-0 top-0 bottom-0 w-10 z-[5] pointer-events-none bg-gradient-to-l from-background to-transparent" />
        )}
        <TabsList
          ref={tabsScrollRef}
          className="-mx-4 px-10 sm:mx-0 sm:px-10 w-[calc(100%+2rem)] sm:w-full justify-start overflow-x-auto bg-transparent border-b border-border rounded-none h-auto p-0 gap-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden scroll-smooth"
        >
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className="data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none px-4 sm:px-6 py-3 sm:py-4 gap-2 whitespace-nowrap text-sm"
                data-testid={`tab-${tab.value}`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </div>
    </Tabs>
  );
};

export default DiscoveryTabs;
